import { AsNumber, AsDatePicker, AsSelect } from '@adserve/adserve-react-components';
import React, { useContext, useEffect } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { labelStyle, inputStyle } from './CampaignBriefStyles';
import moment from 'moment';
import { sectionedPanelStyle } from '../CampaignStyles';
import AsSelectFixed from '../../generic/AsSelectFixed';

const errorStyle = {
    border: 'solid 1px #C40606',
    backgroundColor: '#FFF3F3'
};

const statusLabelStyle = {
    position: 'absolute',
    color: '#C40606',
    fontSize: 12
};

const CampaignForecasting = ({
    campaignStages,
    forecastCategories,
    campaign,
    updateCampaign,
    readOnly,
    errorValidationDates,
    setErrorValidationDates
}) => {
    const { dateFormat, formatNumber } = useContext(SystemSettingsContext);

    const validateDates = (startDate, closeDate) => {
        if (startDate && closeDate && closeDate > startDate) {
            setErrorValidationDates('The Close Date cannot be later than the Campaign Start Date');
        } else {
            setErrorValidationDates('');
        }
    };
    useEffect(() => validateDates(campaign.startDate, campaign.closeDate), [campaign.startDate, campaign.closeDate]);

    const handleCampaignStageChange = (e) => {
        if (e.target.value === '-1') {
            // If Select... is chosen, reset all fields
            updateCampaign('campaignStageId', null);
            updateCampaign('forecastCategoryId', null);
            updateCampaign('probability', null);
            updateCampaign('closeDate', null);
            return;
        }
        const campaignStage = campaignStages.find((cs) => cs.id === e.target.value);
        if (campaignStage) {
            campaign.campaignStageId = campaignStage.id;
            const startDate = moment().utc(true).startOf('day');
            updateCampaign('campaignStageId', campaignStage.id);

            campaign.forecastCategoryId = campaignStage.forecastCategoryId;
            campaign.probability = campaignStage.propability;
            campaign.closeDate = startDate;
            updateCampaign('forecastCategoryId', campaignStage.forecastCategoryId);
            updateCampaign('probability', campaignStage.probability);
            updateCampaign('closeDate', startDate);

            validateDates(campaign.startdate, startDate);
        }
    };

    const handleForecastCategoryChange = (e) => {
        campaign.forecastCategoryId = e.target.value;
        updateCampaign('forecastCategoryId', e.target.value);
    };

    const handleProbabilityChange = (e) => {
        const probability = Math.max(Math.min(e.target.value, 0), 100);
        campaign.probability = probability;
        updateCampaign('probability', e.target.value);
    };

    const handleCloseDateChange = (e) => {
        const value = moment(e.target.value).utc(true).startOf('day');
        campaign.closeDate = value;
        updateCampaign('closeDate', value);
        validateDates(campaign.startdate, value);
    };

    const isRunningCampaign = () => {
        return campaign.versionNumber > 0 && new Date(Date.parse(campaign?.startDate)) <= new Date();
    };
    return (
        <div
            style={{
                ...sectionedPanelStyle,
                padding: '10px 230px 18px',
                display: 'grid',
                gap: '0 80px',
                boxSizing: 'border-box',
                width: '100%',
                gridTemplateColumns: 'repeat(4, 1fr)'
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', gridColumn: '1 / -1', paddingBottom: 10 }}>
                <span style={{ fontSize: 15, fontWeight: 500 }}>{window.translate('Campaign Forecasting')}</span>
            </div>
            <AsSelectFixed
                id='campaign-forecast-stage'
                name='campaignStageId'
                labelStyle={labelStyle}
                selectStyle={inputStyle}
                values={campaignStages}
                value={campaign?.campaignStageId ?? { id: -1 }}
                onChange={handleCampaignStageChange}
                disabled={readOnly || isRunningCampaign()}
                title={window.translate('Campaign Stage')}
                disabledValues={['Booked', 'Qualified Out']}
                disableTooltip
            />
            <AsSelectFixed
                id='campaign-forecast-category'
                name='forecastCategoryId'
                labelStyle={labelStyle}
                selectStyle={inputStyle}
                values={forecastCategories}
                value={campaign?.forecastCategoryId ?? { id: -1 }}
                onChange={handleForecastCategoryChange}
                disabled={readOnly || isRunningCampaign()}
                title={window.translate('Forecast Category')}
                placeholder={campaign?.campaignStageId ? null : ' '}
                disableTooltip
            />
            <div>
                <AsNumber
                    id='campaign-forecast-probability'
                    name='probability'
                    title={window.translate('Probability')}
                    labelStyle={labelStyle}
                    inputStyle={inputStyle}
                    value={campaign.probability}
                    onChange={handleProbabilityChange}
                    disabled={readOnly}
                    allowFloat={false}
                    formatNumber={formatNumber}
                    digitLimit={5}
                />
            </div>

            <div>
                <label style={labelStyle}>{window.translate('Close Date')}</label>
                <AsDatePicker
                    id='campaign-forecast-close-date'
                    name='closeDate'
                    labelStyle={labelStyle}
                    inputStyle={{ ...inputStyle, ...(errorValidationDates ? errorStyle : {}) }}
                    currentDate={campaign?.closeDate}
                    placeholder=''
                    onChange={handleCloseDateChange}
                    disabled={readOnly || isRunningCampaign()}
                    dateFormat={dateFormat}
                    containerStyle={{ width: '100%' }}
                    style={{ flexWrap: 'no-wrap' }}
                    buttonStyle={{ width: 56 }}
                />
                {errorValidationDates && <label style={statusLabelStyle}>{errorValidationDates}</label>}
            </div>
        </div>
    );
};

export default CampaignForecasting;
